export async function readFile(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = () => {
            resolve(fileReader.result as ArrayBuffer)
        }
        fileReader.onerror = (e) => {
            reject(e)
        }
        fileReader.readAsArrayBuffer(file)
    })
}